import { ComponentProps } from 'react';

import { Cryptocurrency } from '__generated__/globalTypes';
import { useCryptoBalance } from 'hooks/useCryptoBalance';

import { EthWalletIcon } from '../EthWalletIcon';
import { SolanaWalletIcon } from '../SolanaWalletIcon';

type Props = Pick<ComponentProps<typeof EthWalletIcon>, 'size'>;

export const CryptoWalletIcon = ({ size }: Props) => {
  const { cryptocurrency } = useCryptoBalance();
  switch (cryptocurrency) {
    case Cryptocurrency.LAMPORT:
      return <SolanaWalletIcon size={size} />;
    default:
    case Cryptocurrency.WEI:
      return <EthWalletIcon size={size} />;
  }
};
